import { render } from "./AssistantDrawer.vue?vue&type=template&id=26d31640&scoped=true"
import script from "./AssistantDrawer.vue?vue&type=script&lang=js"
export * from "./AssistantDrawer.vue?vue&type=script&lang=js"

import "./AssistantDrawer.vue?vue&type=style&index=0&id=26d31640&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d31640"]])

export default __exports__